export const LangToggle = ({ lang, setLang, sound, t }) => (
  <nav className="as-lang" aria-label="Language">
    <button
      type="button"
      className={`as-sound ${sound.playing ? "is-active" : ""}`}
      aria-pressed={sound.playing}
      onClick={sound.toggle}
      data-sound-toggle
      data-testid="sound-toggle"
    >
      {t.sound}
    </button>
    <span className="as-lang-sep" aria-hidden="true" />
    {["en", "it"].map((code) => (
      <button
        key={code}
        type="button"
        className={lang === code ? "is-active" : ""}
        aria-pressed={lang === code}
        onClick={() => setLang(code)}
        data-testid={`lang-toggle-${code}`}
      >
        {code.toUpperCase()}
      </button>
    ))}
  </nav>
);
